// This file can be removed when Prismic fix the issue affecting Edge, which does not support
// the spread operator.
// https://github.com/prismicio/apollo-link-prismic/blob/master/src/index.js

import { setContext } from "apollo-link-context";
import { HttpLink } from "apollo-link-http";
import Prismic from "prismic-javascript";

function removeWhiteSpace(str) {
  const regexp = /(%0A|%20)*(%20|%7B|%7D)(%0A|%20)*/g;

  const [path, query] = str.split("?");
  if (!query) return str;

  const shortQuery = query
    .split("&")
    .map((param) => {
      const [name, value] = param.split("=");
      if (name === "query") {
        return (
          name +
          "=" +
          value.replace(regexp, (chars, spaces, brackets) => brackets)
        );
      }
      return param;
    })
    .join("&");

  return [path, shortQuery].join("?");
}

const PRISMIC_ENDPOINT_REG =
  /^https?:\/\/([^.]+)\.(?:cdn\.)?(wroom\.(?:test|io)|prismic\.io)\/graphql\/?/;
//                                        ^                  ^
//                                        1                  2

function parsePrismicEndpoint(endpoint) {
  const tokens = endpoint.match(PRISMIC_ENDPOINT_REG);

  if (tokens !== null && Array.isArray(tokens) && tokens.length === 3) {
    const [, /* endpoint */ repository, domain] = tokens;

    return `https://${repository}.cdn.${domain}`; // enforce the cdn
  }

  return null; // not from prismic ? returns null.
}

/**
 * TODO. After the rebrand is launched, delete the below, and hardcode
 * the Prismic Ref to the master ref.
 */
const REBRAND_2021_RELEASE_REF_ID = "YPresBAAAGdkvJGx";
const getPrismicRef = (api) => {
  const rebrand2021Ref = api.refs.find(
    (r) => r.id === REBRAND_2021_RELEASE_REF_ID
  )?.ref;

  return rebrand2021Ref ?? api.masterRef.ref;
};
// TODO. Delete the above.

export function PrismicLink({ uri, accessToken, repositoryName, ...options }) {
  const prismicEndpoint = parsePrismicEndpoint(uri); // enforce cdn if it's the prismic endpoint

  if (prismicEndpoint && repositoryName) {
    console.warn(
      "`repositoryName` is ignored since the graphql endpoint is valid."
    );
  }

  if (!prismicEndpoint && !repositoryName) {
    throw Error(
      "Since you are using a custom GraphQL endpoint, you need to provide to PrismicLink your repository name as shown below:\n" +
        "PrismicLink({\n" +
        "  uri: 'https://mycustomdomain.com/graphql',\n" +
        "  accessToken: 'my_access_token', // could be undefined\n" +
        "  repositoryName: 'my-prismic-repository'\n" +
        "})\n"
    );
  }

  let apiEndpoint;
  let gqlEndpoint;

  if (prismicEndpoint) {
    apiEndpoint = `${prismicEndpoint}/api`;
    gqlEndpoint = `${prismicEndpoint}/graphql`;
  } else {
    apiEndpoint = `https://${repositoryName}.cdn.prismic.io/api`;
    gqlEndpoint = uri;
  }

  const prismicClient = Prismic.client(apiEndpoint, { accessToken });

  const prismicLink = setContext((request, previousContext) => {
    return prismicClient.getApi().then((api) => ({
      headers: {
        "Prismic-ref": getPrismicRef(api), // TODO. Revert to `api.masterRef.ref`
        ...previousContext.headers,
        ...(api.integrationFieldRef
          ? { "Prismic-integration-field-ref": api.integrationFieldRef }
          : {}),
        ...(accessToken ? { Authorization: `Token ${accessToken}` } : {}),
      },
    }));
  });

  const httpLink = new HttpLink({
    uri: gqlEndpoint,
    useGETForQueries: true,
    fetch: (url, options) => {
      const trimmed = removeWhiteSpace(url);
      return fetch(trimmed, options);
    },
    ...options,
  });

  return prismicLink.concat(httpLink);
}

export default {
  PrismicLink,
};
